import { render, staticRenderFns } from "./MISPromoClientComponent.vue?vue&type=template&id=a753bd0e"
import script from "./MISPromoClientComponent.vue?vue&type=script&lang=js"
export * from "./MISPromoClientComponent.vue?vue&type=script&lang=js"
import style0 from "./MISPromoClientComponent.vue?vue&type=style&index=0&id=a753bd0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports